import * as React from 'react'

import { cn } from '../../lib/utils'
const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, name, autoComplete, ...props }, ref) => {
    return (
      <input
        type={type}
        name={name}
        data-slot="input"
        autoComplete={autoComplete}
        className={cn(
          'file:text-foreground placeholder:text-current selection:bg-primary selection:text-primary-foreground border-input bg-transparent flex h-9 w-full min-w-0 rounded-md border px-3 py-1 text-base transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          'focus-visible:border-primary focus-visible:ring-primary focus-visible:ring-[1px]',
          'aria-invalid:ring-destructive/20 aria-invalid:border-destructive',
          className,
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
export { Input }
